import { SvgIcon, SvgIconProps } from "@mui/material";

export const CodeIcon = ({ ...props }: SvgIconProps) => {
	return (
		<SvgIcon xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none" {...props}>
			<path
				d="M4.83333 4.66732L1.5 8.00065L4.83333 11.334M13.1667 4.66732L16.5 8.00065L13.1667 11.334M10.6667 1.33398L7.33333 14.6673"
				stroke="var(--secondary-color)"
				strokeOpacity="0.85"
				strokeWidth="1.25"
				strokeLinecap="round"
				strokeLinejoin="round"
				fill="none"
			/>
		</SvgIcon>
	);
};
